<template>
  <div class="home-page">
    <Header />
    <transition name="fade-transform" mode="out-in">
      <router-view :key="$route.path" />
    </transition>
    <Fixed />
    <BackTop />
    <Footer />
  </div>
</template>

<script>
import Header from './Header'
import Footer from './Footer'
import BackTop from './BackTop'
import Fixed from './Fixed'


export default {
  name: 'Layout',
  components: {
    Header,
    Footer,
    BackTop,
    Fixed
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .home-page{
    background-color: #fafcff
  }
</style>
